import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tours-page',
  templateUrl: './tours-page.component.html',
  styleUrls: ['./tours-page.component.css']
})
export class ToursPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
